(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["multi-column"] && !Shopify.designMode) return;
  try {
    
  (function() {
    window.addEventListener('DOMContentLoaded', () => {
      const videoModal = document.querySelector('.image-wrap--modal');

      if (videoModal) {
        const modals = document.querySelectorAll(".image-wrap--modal [data-modal]");
        const openButtons = document.querySelectorAll(".image-wrap--modal .video-play-button");
        const closeButtons = document.querySelectorAll(".image-wrap--modal [data-close-modal]");
    
        openButtons.forEach((openButton, index) => {
          const modal = modals[index];
          const closeButton = closeButtons[index];
    
          openButton.addEventListener('click', () => {
            modal.showModal();
            modal.classList.add("fade");
            
            // Play the video
            var videoPlayer = modal.querySelector('iframe');
            videoPlayer.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
          });
    
          closeButton.addEventListener('click', () => {
            modal.close();
            modal.classList.remove("fade");

            // Pause the video
            var videoPlayer = modal.querySelector('iframe');
            videoPlayer.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          });
    
          modal.addEventListener("click", (e) => {
            const dialogDimensions = modal.getBoundingClientRect();
            if (
              e.clientX < dialogDimensions.left ||
              e.clientX > dialogDimensions.right ||
              e.clientY < dialogDimensions.top ||
              e.clientY > dialogDimensions.bottom
            ) {
              modal.close();
              modal.classList.remove("fade");

              // Pause the video
              var videoPlayer = modal.querySelector('iframe');
              videoPlayer.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');              
            }
          });
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
